import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import adocc from '../assets/img/adocc.png';
import bpi from '../assets/img/bpi_france.png';
import frenchTech from '../assets/img/french_tech.png';
import crealia from '../assets/img/LOGO-CREALIA.png';
import imt from '../assets/img/mines_ales.png';
import ales from '../assets/img/ales_agglomeration_logo.png';
import unionEuropeenne from '../assets/img/logo-union-europeenne.png';
import fse from '../assets/img/FSE-OCCITANIE.jpg';
import garDigital from '../assets/img/logo-gardigital.png';
import Card from '../common/Card';

class PartnersComp extends PureComponent {
  render() {
    return (
      <Container className="container-full partners-container">
        <div className="partners-title">
          <span className="bold-word">Comme eux</span>, adoptez dès à présent <span className="bold-word">le ticket dématérialisé</span>
          <br/>
          Ils nous font <span className="bold-word">confiance</span>
        </div>
        <div className="partners-cards">
          <Row>
            <Col xs={12} lg={4} className="card-col">
              <Card img={imt} title={'Incubateur Ales'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={bpi} title={'BPI France'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={adocc} title={'Ad\'Occ'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={crealia} title={'Créalia'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={ales} title={'Alès Agglomération'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={fse} title={'l\'Europe s\'engage'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
            <Col xs={12} lg={4} className="card-col">
              <Card img={unionEuropeenne} title={'Union Européenne'} width="100%" customClass="partner-card-item" customTitleClass="partner-card-title" />
            </Col>
          </Row>
          <Row className="align-items-end bonus-partners">
            <Col xs={12} sm={{span: 4, offset: 4}} lg={{span: 3, offset: 6}} xl={{span: 2, offset: 8}}>
              <img src={garDigital} title={'garDigital'} alt={'garDigital'} className="card-img"/>
            </Col>
            <Col xs={12} sm={4} lg={3} xl={2}>
              <img src={frenchTech} title={'French Tech Digital'} alt={'French Tech Digital'} className="card-img"/>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default PartnersComp;
